angular.module 'zc.master.reports'

.constant 'masterReportsCsvHeaders', [
  'title'
  'apikey'
  'product_line'
  'contracted_at'
  'trial_started_at'
  'trial_end_at'
  'terminated_at'
  'status'
  'project_rank'
  'campaign_count'
  'all_access.conversion_price'
  'contribution_count'
  'contribution_price'
  'invoice_amount'
  'invoice_amount_rate'
  'goal_percentage'
  'trial.all_access.conversion_price'
  'trial.contribution_count'
  'trial.contribution_price'
  'trial.invoice_amount'
  'contracted.all_access.conversion_price'
  'contracted.contribution_count'
  'contracted.contribution_price'
  'contracted.invoice_amount'
  'budget'
]



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.reports/master_reports_csv_headers.coffee